import React from 'react';
import { Container } from 'reactstrap';
import CreateFormInput from './CreateFormInput';
import { colors } from '../Utils/Colors';
import { serverUrls, makeUrl, clientUrls } from '../Utils/Urls';
import { redirectTo } from '../Utils/RedirectUtil';

const formInputs = {
    name: {
        type: 'text',
        required: true,
        placeholder: 'name',
        label: 'Name'
    },
    age: {
        type: 'number',
        required: true,
        placeholder: 'age',
        label: 'Age'
    },
    sex: {
        type: 'select',
        required: true,
        placeholder: 'name',
        values: {
            Male: 'M',
            Female: 'F'
        },
        label: 'Sex'
    },
    crno: {
        type: 'text',
        required: true,
        placeholder: 'cr no',
        label: 'CR No'
    },
    admissionno: {
        type: 'text',
        required: false,
        placeholder: 'admission no',
        label: 'Admission No.'
    },
    ecno: {
        type: 'text',
        required: false,
        placeholder: 'ec no',
        label: 'EC No.'
    },
    DOA: {
        type: 'datepicker',
        required: false,
        placeholder: 'DOA',
        label: 'DOA'
    },
    DOS: {
        type: 'datepicker',
        required: false,
        placeholder: 'DOS',
        label: 'DOS'
    },
    DOD: {
        type: 'datepicker',
        required: false,
        placeholder: 'DOD',
        label: 'DOD'
    },
    DOR: {
        type: 'datepicker',
        required: false,
        placeholder: 'DOR',
        label: 'Date Of recruitment of patient'
    },
    address: {
        type: 'text',
        required: true,
        placeholder: 'address',
        label: 'Address'
    },
    telephone: {
        type: 'text',
        required: false,
        placeholder: 'telephone',
        label: 'Telephone'
    },
    mobile: {
        type: 'text',
        required: true,
        placeholder: 'mobile',
        label: 'Mobile'
    },
    email: {
        type: 'email',
        required: false,
        placeholder: 'email',
        label: 'Email'
    },
    aadharCard: {
        type: 'text',
        required: false,
        placeholder: 'aadhar card',
        label: 'Aadhar Card'
    // },
    // parents: {
    //     type: 'text',
    //     required: false,
    //     placeholder: 'parents',
    //     label: 'Parents'
    // },
    // grandparents: {
    //     type: 'text',
    //     required: false,
    //     placeholder: 'grandparents',
    //     label: 'Grand Parents'
    },
    consent: {
        type: 'select',
        required: true,
        placeholder: 'consent',
        values: {
            Yes: 'Y',
            No: 'N'
        },
        label: 'Have you taken the consent?'
    }
}


class NewPatient extends React.Component {

    afterCall(id) {
        var url = makeUrl(clientUrls.editPatient, 'id', id);
        redirectTo(url);
    }

    render() {
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>Patient Details</h4>
                <br/>
                <CreateFormInput afterCall={this.afterCall} buttonName="Save And Continue" url={serverUrls.patient} formName="patientDetailsForm" inputs={formInputs} />
                <br/>
                <br/>
                <hr className="my-2" />
                <div style={{textAlign: "center"}}>
                    <p>Department of Endocrinology<br/>
                    Postgraduate Institute of Medical Education &amp; Research<br/>
                    Chandigarh, India - 160012</p>
                    <p className="lead">
                    </p>
                </div>
            </Container>
        )
    }
}

export default NewPatient;
